export { Delivery } from './lib/delivery'
export { getStaticProps } from './lib/get-static-props'
